module.exports = __webpack_public_path__ + "assets/73511cab9e05c7e5c443726e09349ff5.jpg";